import React from "react";
import styled from "styled-components";
import eyeIcon from "assets/icons/eye-open.svg";
import eyeCloseIcon from "assets/icons/eye-close.svg";

const InputWrapper = styled.div`
  position: relative;
  margin-bottom: 25px;
  label {
    margin-bottom: 20px;

    display: block;
    /* font-size: 0.8rem; */
  }
  img {
    position: absolute;
    right: 10px;
    bottom: 10px;
  }
`;

const Input = styled.input`
  position: relative;
  display: inline-block;
  width: ${({ width }) => width || "100%"};
  min-width: 0;
  padding: ${({ padding }) => padding || "10px"};
  outline: none;
  height: ${({ height }) => height || "40px"};

  color: rgba(0, 0, 0, 0.65);
  font-size: 13px;
  line-height: 1.5715;
  background-color: ${({ bgColor }) => bgColor || "#fff"};
  background-image: none;
  border: 1px solid #e4e9f0;
  border-radius: ${({ bRadius }) => bRadius || 0};
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  display: -ms-inline-flexbox;
  display: inline-flex;
  &:focus {
  }
`;

const InputField = ({
  label,
  type = "text",
  required,
  name,
  onChange,
  value,
  error,
  placeholder = "",
  topText,
  min,
  max,
  id,
  bRadius,
  height,
  bgColor,
  padding,
  disabled,
  width,
}) => {
  const [isVisible, setIsVisible] = React.useState(false);

  return (
    <InputWrapper>
      {/* {topText && <InputHeader>{topText}</InputHeader>} */}
      {label && (
        <label>
          {label}
          {required && (
            <span className="error" style={{ marginLeft: "5px" }}>
              *
            </span>
          )}
        </label>
      )}

      <Input
        type={isVisible ? "text" : type}
        placeholder={placeholder}
        name={name}
        onChange={onChange}
        value={value}
        data-test-id="input"
        min={min}
        max={max}
        id={id}
        bRadius={bRadius}
        height={height}
        bgColor={bgColor}
        padding={padding}
        disabled={disabled}
        width={width}
        required={required}
      />

      {type === "password" && (
        <img
          src={isVisible ? eyeCloseIcon : eyeIcon}
          alt=""
          onClick={() => setIsVisible((isVisible) => !isVisible)}
          width="15px"
        />
      )}
      {error ? <p className="error">{error}</p> : ""}
    </InputWrapper>
  );
};

export default InputField;
